import { useQuery } from "@tanstack/react-query";
import api from "../api";
import urls from "../urls";
import type { AdvancePaymentsPlan } from "../utils/backend-types";

export function useAdvancePayments(projectId: string) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["advancePaymentsPlans", { projectId }],
    queryFn: () => fetchAdvancePayments(projectId)
  });

  return { data, isLoading, error };
}

async function fetchAdvancePayments(
  projectId: string
): Promise<Array<AdvancePaymentsPlan>> {
  const advancePaymentsPlansUrl = urls.api.advancePaymentsPlans(projectId);
  const response = await api.get<Array<AdvancePaymentsPlan>>(
    advancePaymentsPlansUrl
  );

  return response.data;
}
